module.exports = __webpack_public_path__ + "media/RuskaNargila.b4e4a5be.webm";